import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email(msg("emailInvalid"))
    .matches(validationPatterns.email, msg("emailFormat"))
    .required(msg("emailRequired")),
  password: Yup.string()
    .matches(
      validationPatterns.password,
      msg("passwordPattern")
    )
    .min(6, msg("passwordMin"))

    .required(msg("passwordRequired")),
});
